import { useCallback, useLayoutEffect, useState } from 'react';
import IvicosStrings from 'kits/language/stringKit';

export type LandingUiLang = 'en' | 'de';

export function readStoredLandingLanguage(): LandingUiLang {
    const raw = localStorage.getItem('UserLanguageChoice') || localStorage.getItem('chosenLanguage');
    if (raw === 'en' || raw === 'de') {
        return raw;
    }
    return navigator.language.includes('de') ? 'de' : 'en';
}

/**
 * Keeps IvicosStrings, localStorage, and React state in sync so landing UI re-renders
 * (singleton string changes do not trigger re-renders by themselves).
 */
export function useLandingInterfaceLanguage(): {
    interfaceLanguage: LandingUiLang;
    setLandingLanguage: (lang: LandingUiLang) => void;
} {
    const [interfaceLanguage, setInterfaceLanguage] = useState<LandingUiLang>(readStoredLandingLanguage);

    useLayoutEffect(() => {
        const lang = readStoredLandingLanguage();
        IvicosStrings.setLanguage(lang);
        setInterfaceLanguage(lang);
    }, []);

    const setLandingLanguage = useCallback((lang: LandingUiLang) => {
        IvicosStrings.setLanguage(lang);
        localStorage.setItem('UserLanguageChoice', lang);
        localStorage.setItem('chosenLanguage', lang);
        setInterfaceLanguage(lang);
    }, []);

    return { interfaceLanguage, setLandingLanguage };
}
